/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylistV2 } from 'src/core/themes/luisStylist';
import { StyledStack } from 'src/luis/verticals/getStartedGuide/components/GetStartedList';

const messages = defineMessages({
    designSchemaItemBody: {
        id: 'portal.getStartedList.designSchemaItemBody',
        defaultMessage: 'Before you create your LUIS app, design your intent and entity schema to match your end user scenarios.'
    },
    designSchemaItemLink: {
        id: 'portal.getStartedList.designSchemaItemLink',
        defaultMessage: 'Best practices for designing your app.'
    }
});

const urls = {
    design: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-concept-best-practices'
};

const { styleAnchor } = getStylistV2('GetStartedGuide');

const StyledAnchor = styleAnchor('StyledAnchor', {
    marginTop: 18
});

export const DesignListItem = () => {
    const { localize } = useLocalization();

    return (
        <StyledStack>
            {localize(messages.designSchemaItemBody)}
            <StyledAnchor href={urls.design}>{localize(messages.designSchemaItemLink)}</StyledAnchor>
        </StyledStack>
    );
};
